import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Meta, Title} from '@angular/platform-browser';
import {UtilitiesService} from '../service/utilities.service';
import {StatePersistenceService} from '../service/state.persistence.service';
import {BaseComponent} from '../common/component/base/base.component';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {BreadcrumbService} from '../service/breadcrumb.service';
import {filter} from 'rxjs/operators';

const selector: string = 'residential-solar';

@Component({
    selector: selector,
    templateUrl: './residential-solar.component.html',
    styleUrls: ['./residential-solar.component.scss']
})
export class ResidentialSolarComponent extends BaseComponent {

    activated: boolean;

    constructor(@Inject(DOCUMENT) public override document: Document,
                private title: Title,
                private meta: Meta,
                private utilities: UtilitiesService,
                private state: StatePersistenceService,
                private route: ActivatedRoute,
                router: Router,
                breadcrumbService: BreadcrumbService) {
        super(document, router, breadcrumbService);
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any): void => {
            const url: string = event.url;
            this.activated = (url.substring(url.lastIndexOf('/') + 1) === selector);
        });
    }
}
